import React from 'react';
import ClientDashboard from './ClientDashboard';

function MyProjects() {
  return <ClientDashboard defaultTab="all" />;
}

export default MyProjects;